import React from 'react';
import soloImage from 'assets/images/solo_logo.png';
import { Image } from 'components/image/Image';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useFlowStep } from 'hooks/useFlowStep/useFlowStep';
import { FEELIX_THEMES } from '../../constants';
import style from './logo.module.scss';

export const SoloLogo: React.FC = () => {
  const { theme } = useSessionContext();
  const flowStep = useFlowStep();
  if (theme !== FEELIX_THEMES.SOLO) {
    return null;
  }

  return (
    <Image
      alt='solo'
      src={soloImage}
      // hide on first page when mobile view
      className={`${style.soloLogo} ${flowStep === -1 && style.hideLogo}`}
    />
  );
};
